import { cn } from "../../../lib/cn";
import { HiOutlineCircleStack } from "react-icons/hi2";

const formatBytes = (bytes) => {
  if (bytes === 0) return "0 B";
  const k = 1024;
  const sizes = ["B", "KB", "MB", "GB", "TB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
};

export const UsageMeter = ({ usedBytes = 0, quotaBytes = 0, isLoading }) => {
  const percent = quotaBytes > 0 ? (usedBytes / quotaBytes) * 100 : 0;
  const freeBytes = Math.max(0, quotaBytes - usedBytes);
  const color =
    percent < 60 ? "bg-secondary" : percent < 80 ? "bg-warning" : "bg-danger";

  return (
    <div className="bg-white rounded-xl p-5 border border-surface-border">
      <div className="flex items-center gap-2 mb-4">
        <HiOutlineCircleStack className="w-5 h-5 text-darkgrey" />
        <p className="text-sm font-semibold text-darkgrey">Storage</p>
      </div>

      {isLoading ? (
        <div className="space-y-3">
          <div className="h-4 bg-surface-active rounded animate-pulse w-3/4" />
          <div className="h-2 bg-surface-active rounded animate-pulse" />
          <div className="h-3 bg-surface-active rounded animate-pulse w-1/2" />
        </div>
      ) : (
        <>
          <div className="flex items-end justify-between mb-3">
            <p className="text-sm text-darkgrey">
              <span className="font-bold text-lg">{formatBytes(usedBytes)}</span>
              <span className="text-grey"> of {formatBytes(quotaBytes)}</span>
            </p>
            <span className="text-sm font-medium text-secondary-dark">{Math.round(percent)}%</span>
          </div>

          <div className="w-full h-2 bg-surface-hover rounded-full overflow-hidden mb-3">
            <div
              className={cn("h-full rounded-full transition-all duration-500 ease-out", color)}
              style={{ width: `${Math.min(percent, 100)}%` }}
            />
          </div>

          <p className="text-xs text-grey">{formatBytes(freeBytes)} free</p>
        </>
      )}
    </div>
  );
};
